import { render } from "./NeedSubscription.expires.vue?vue&type=template&id=c789b7d8&scoped=true"
import script from "./NeedSubscription.expires.vue?vue&type=script&lang=js"
export * from "./NeedSubscription.expires.vue?vue&type=script&lang=js"

import "./NeedSubscription.expires.vue?vue&type=style&index=0&id=c789b7d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c789b7d8"]])

export default __exports__